import { deleteFillInTheBlankQuestion } from '@/data/services/question/fillInTheBlankQuestionServices';
import { deleteOrderingQuestion } from '@/data/services/question/orderingQuestionServices';
import { deletePositionalQuestion } from '@/data/services/question/positionalQuestionServices';
import { deleteQuizQuestion } from '@/data/services/question/quizQuestionServices';
import { deleteTextQuestion } from '@/data/services/question/textQuestionServices';
import { deleteTrueOrFalseQuestion } from '@/data/services/question/trueOrFalseQuestionServices';
import { deleteWritingQuestion } from '@/data/services/question/writingQuestionServices';
import { deleteFlashcardQuestion } from '@/data/services/question/flashcardQuestionServices';
import { QuestionTypeEnum } from '@/models/Question';

type DeleteQuestionParams = {
  id: number;
  type: QuestionTypeEnum;
};

const services: Partial<
  Record<QuestionTypeEnum, (id: number) => Promise<void>>
> = {
  [QuestionTypeEnum.TEXT]: deleteTextQuestion,
  [QuestionTypeEnum.QUIZ]: deleteQuizQuestion,
  [QuestionTypeEnum.TRUE_OR_FALSE]: deleteTrueOrFalseQuestion,
  [QuestionTypeEnum.WRITING]: deleteWritingQuestion,
  [QuestionTypeEnum.DND_ORDENATION]: deleteOrderingQuestion,
  [QuestionTypeEnum.DND_POSITIONAL]: deletePositionalQuestion,
  [QuestionTypeEnum.FILL_IN_THE_BLANK]: deleteFillInTheBlankQuestion,
  [QuestionTypeEnum.FLASHCARD]: deleteFlashcardQuestion,
};

const deleteQuestion = async ({ id, type }: DeleteQuestionParams) => {
  const service = services[type];
  if (!service) throw new Error(`Unsupported question type: ${type}`);
  return service(id);
};

export default deleteQuestion;
